/**
 * LeaseMDLogo — SVG oficial de leasemd.mx embebido.
 *
 * variant="auto"    → LEASE navy (#383e56) en light, blanco en dark  [default]
 * variant="inverse" → LEASE siempre blanco (para fondos oscuros)
 * MD ®              → siempre azul #0d6efd
 */
interface Props {
  className?: string
  variant?: 'auto' | 'inverse'
}

export function LeaseMDLogo({ className = 'h-5 w-auto', variant = 'auto' }: Props) {
  const leaseClass =
    variant === 'inverse' ? 'fill-white' : 'fill-surface-700 dark:fill-white'

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 149.342 25.026"
      className={className}
      aria-label="LeaseMD"
      role="img"
    >
      <g className={leaseClass}>
        <path transform="translate(0 3.557) translate(-89.6 -114.1)" d="M101.826,135.35H89.6V114.1h1.186v20.1h11.04Z" />
        <path transform="translate(19.263 3.557) translate(-214.7 -114.1)" d="M226.818,135.35H214.7V114.1h12.057v1.139H215.87v8.885h10.64v1.155H215.87v8.931h10.948Z" />
        <path transform="translate(35.839 3.388) translate(-331.8 -113)" d="M349.831,134.419h-1.247l-2.818-6.914h-9.932l-2.787,6.914H331.8L340.346,113h.97Zm-13.52-8.038h9.008l-4.527-11.6Z" />
        <path transform="translate(58.826 3.279) translate(-486.8 -112.293)" d="M494.237,134.037c-3.28,0-6.975-1.879-7.345-5.343l-.092-.539,1.17-.154.077.554c.292,2.726,3.388,4.342,6.2,4.342a7.1,7.1,0,0,0,5.436-2.279,4.264,4.264,0,0,0,.831-3.711c-.57-2.618-3.28-2.895-6.159-3.187-3.3-.323-7.022-.708-7.314-5.066a5.167,5.167,0,0,1,1.047-3.68c1.678-2.171,5.189-3.187,8.361-2.433a5.8,5.8,0,0,1,4.727,4.512l.077.585-1.139.231-.062-.6a4.25,4.25,0,0,0-1.032-2.048,6.565,6.565,0,0,0-4.881-1.771,6.49,6.49,0,0,0-5.112,2.217,4.044,4.044,0,0,0-.847,2.91c.246,3.4,3.08,3.68,6.344,4,3,.293,6.406.631,7.145,4.1a5.312,5.312,0,0,1-1.032,4.6,8.3,8.3,0,0,1-6.4,2.76Z" />
        <path transform="translate(80.173 3.557) translate(-630.5 -114.1)" d="M642.618,135.35H630.5V114.1h12.057v1.139H631.67v8.885h10.656v1.155H631.67v8.931h10.948Z" />
      </g>
      <g fill="#0d6efd">
        <path transform="translate(97.401 3.542) translate(-748 -114)" d="M751.049,135.265H748V114h2.479l6.975,10.409L764.414,114h2.417v21.265h-3.018V120.39l-5.513,8.192h-1.725l-5.528-8.192Z" />
        <path transform="translate(120.885 3.557) translate(-909.3 -114.1)" d="M916.876,114.1c6.914,0,10.378,5.436,10.378,10.717s-3.465,10.533-10.378,10.533H909.3V114.1Zm0,18.186c4.881,0,7.36-3.742,7.36-7.484s-2.479-7.514-7.36-7.514h-4.527v15Z" />
        <path transform="translate(142.35) translate(-1048.7 -91)" d="M1055.691,94.572a3.518,3.518,0,1,1-1-2.509,3.5,3.5,0,0,1,1,2.509m-6.128,0a2.71,2.71,0,0,0,2.664,2.849,2.86,2.86,0,0,0-.031-5.7,2.723,2.723,0,0,0-2.633,2.849m2.094,1.894h-.786v-3.57a7.057,7.057,0,0,1,1.309-.108,2.024,2.024,0,0,1,1.186.262,1.017,1.017,0,0,1,.339.785.922.922,0,0,1-.708.832v.046a1.013,1.013,0,0,1,.616.878,2.843,2.843,0,0,0,.246.893h-.847a3.639,3.639,0,0,1-.277-.878c-.062-.385-.278-.554-.708-.554h-.369v1.417Zm.031-2.048h.369c.431,0,.785-.154.785-.524,0-.339-.231-.539-.739-.539a1.382,1.382,0,0,0-.431.046v1.016Z" />
      </g>
    </svg>
  )
}
